import { render } from "./LandingTest.vue?vue&type=template&id=22ae2734&scoped=true"
import script from "./LandingTest.vue?vue&type=script&lang=js"
export * from "./LandingTest.vue?vue&type=script&lang=js"

import "./LandingTest.vue?vue&type=style&index=0&id=22ae2734&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ae2734"]])

export default __exports__